import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./CSS/sliderStyles.css";

const CategoryBar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subcategory1, setSubcategory1] = useState({});
  const [subcategory2, setSubcategory2] = useState({});
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [hoveredSubcat1, setHoveredSubcat1] = useState(null);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [catRes, sub1Res, sub2Res] = await Promise.all([
          axios.get("https://dehleze.shop/account/category/"),
          axios.get("https://dehleze.shop/account/subcategory1/"),
          axios.get("https://dehleze.shop/account/subcategory2/"),
        ]);

        setCategories(catRes.data);

        const groupedSub1 = {};
        sub1Res.data.forEach((sub) => {
          const catId = sub.category;
          if (!groupedSub1[catId]) groupedSub1[catId] = [];
          groupedSub1[catId].push(sub);
        });
        setSubcategory1(groupedSub1);

        const groupedSub2 = {};
        sub2Res.data.forEach((sub) => {
          const sub1Id = sub.category1_id;
          if (!groupedSub2[sub1Id]) groupedSub2[sub1Id] = [];
          groupedSub2[sub1Id].push(sub);
        });
        setSubcategory2(groupedSub2);

        localStorage.setItem("categories", JSON.stringify(catRes.data));
        localStorage.setItem("subcategory1", JSON.stringify(sub1Res.data));
        localStorage.setItem("subcategory2", JSON.stringify(sub2Res.data));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAllData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setHoveredCategory(null);
        setHoveredSubcat1(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelection = async (id, level) => {
    if (!id || !level) {
      console.warn("handleSelection requires both id and level.");
      return;
    }

    setIsDropdownOpen(false);
    setHoveredCategory(null);
    setHoveredSubcat1(null);

    let selectedData;
    if (level === "category") {
      selectedData = categories.find((cat) => cat.category_id === id);
    } else if (level === "subcategory1") {
      Object.values(subcategory1).forEach((subList) => {
        const match = subList.find((sub) => sub.category1_id === id);
        if (match) selectedData = match;
      });
    } else if (level === "subcategory2") {
      Object.values(subcategory2).forEach((subList) => {
        const match = subList.find((sub) => sub.category2_id === id);
        if (match) selectedData = match;
      });
    }

    localStorage.removeItem("selected_category");
    localStorage.removeItem("selected_subcategory1");
    localStorage.removeItem("selected_subcategory2");
    localStorage.removeItem("last_selected");

    try {
      localStorage.setItem(
        "last_selected",
        JSON.stringify({ level, id, time: Date.now() })
      );
      if (level === "category") {
        localStorage.setItem("selected_category", JSON.stringify(selectedData));
      } else if (level === "subcategory1") {
        localStorage.setItem(
          "selected_subcategory1",
          JSON.stringify(selectedData)
        );
      } else if (level === "subcategory2") {
        localStorage.setItem(
          "selected_subcategory2",
          JSON.stringify(selectedData)
        );
      }
    } catch (error) {
      console.error("❌ Error saving selection:", error);
    }

    let endpoint = "";
    if (level === "category") {
      endpoint = `https://dehleze.shop/product/category/${id}/`;
    } else if (level === "subcategory1") {
      endpoint = `https://dehleze.shop/product/subcategory1/${id}/`;
    } else if (level === "subcategory2") {
      endpoint = `https://dehleze.shop/product/subcategory2/${id}/`;
    }

    try {
      const response = await axios.get(endpoint);
      localStorage.setItem("selected_products", JSON.stringify(response.data));
      console.log(`✅ Products for ${level} ID ${id}:`, response.data);

      // ✅ Redirect to the ProductsPage
      navigate("/products");
    } catch (err) {
      console.error(`❌ Error fetching products for ${level}:`, err);
    }
  };

  return (
    <div className="h-header">
      <div className="h-header-left">
        <div className="desktop-menu">
          <div className="h-container" ref={dropdownRef}>
            <div
              className="h-category"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              <span>
                <strong className="cate-strong">
                  <i className="fa fa-th-list p-2" aria-hidden="true"></i>
                  All Categories
                </strong>
              </span>

              {isDropdownOpen && (
                <ul className="h-dropdown">
                  {categories.map((category) => (
                    <li
                      key={category.category_id}
                      onMouseEnter={() =>
                        setHoveredCategory(category.category_id)
                      }
                      onClick={() =>
                        handleSelection(category.category_id, "category")
                      }
                    >
                      <Link className="slide-link">{category.name}</Link>

                      {hoveredCategory === category.category_id &&
                        subcategory1[category.category_id] && (
                          <div className="subcategory-box">
                            <ul>
                              {subcategory1[category.category_id].map(
                                (sub1) => (
                                  <li
                                    key={sub1.category1_id}
                                    onMouseEnter={() =>
                                      setHoveredSubcat1(sub1.category1_id)
                                    }
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSelection(
                                        sub1.category1_id,
                                        "subcategory1"
                                      );
                                    }}
                                    className="sub1-item"
                                  >
                                    <Link className="slide-link">
                                      {sub1.name}
                                    </Link>

                                    {hoveredSubcat1 === sub1.category1_id &&
                                      subcategory2[sub1.category1_id] && (
                                        <div className="subcategory-box sub-sub">
                                          <ul>
                                            {subcategory2[
                                              sub1.category1_id
                                            ].map((sub2) => (
                                              <li
                                                key={sub2.category2_id}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleSelection(
                                                    sub2.category2_id,
                                                    "subcategory2"
                                                  );
                                                }}
                                              >
                                                <Link className="slide-link">
                                                  {sub2.name}
                                                </Link>
                                              </li>
                                            ))}
                                          </ul>
                                        </div>
                                      )}
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <div className="yNavFlex">
            <NavLink to="/" className="h-heading">
              Home
            </NavLink>
            <NavLink to="/aboutus" className="h-heading">
              About
            </NavLink>
            <NavLink to="/contactus" className="h-heading">
              Contact Us
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryBar;
